import React, { useEffect } from "react";
import { useSelector } from "react-redux";


const BigCard = () => {
  const wallObj=useSelector((state)=>state.wallDecorItem)
  useEffect(()=>{
    console.log('wallObj',wallObj);
  })

  return (
    <div>
        <h1 className="wallDecor">Wall Decors</h1>
{
  wallObj?.map((item)=>(
    <div style={{display:'flex', margin:'0px 20px', gap:'5px'}} >
      <div class="card" style={{width: '22rem'}}>
        <img src={item.image} class="card-img-top" alt="..." />
        <div class="card-body" >
          <h5 class="card-title">Card title</h5>
          <p class="card-text">
            Some quick example text to build on the card title and make up the
            bulk of the card's content.
          </p>
          <a href="#" class="btn btn-primary">
            Go somewhere
          </a>
        </div>
      </div>
    </div>
  ))
}    

    </div>
  );
};

export default BigCard;
